// Google OAuth配置
export const GOOGLE_CONFIG = {
  // 须通过 VITE_GOOGLE_CLIENT_ID 配置（勿在仓库写死；OAuth Client ID 本就会出现在前端包内）
  CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',

  // API Key（可选，用于某些Google API）
  API_KEY: import.meta.env.VITE_GOOGLE_API_KEY || 'YOUR_GOOGLE_API_KEY',
  
  // OAuth权限范围
  SCOPES: [
    'https://www.googleapis.com/auth/drive.file',
    'https://www.googleapis.com/auth/drive.readonly',
    'https://www.googleapis.com/auth/drive.metadata.readonly',
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/userinfo.email'
  ].join(' '),
  
  // 重定向URI
  REDIRECT_URI: (typeof window !== 'undefined' ? `${window.location.origin}/oauth-callback` : 'http://localhost:5173/oauth-callback'),
  
  // 处理账号邮箱（用于项目文件夹共享）
  PROCESSING_ACCOUNT_EMAIL: import.meta.env.VITE_PROCESSING_ACCOUNT_EMAIL || 'qinhan.jia@t4toon.com'
};

/** Netlify Functions 根 URL（本地可设为 netlify dev 的 origin，例如 http://localhost:8888） */
export function getOAuthFunctionUrl(name: 'google-oauth-exchange' | 'google-oauth-refresh'): string {
  const base = (import.meta.env.VITE_OAUTH_API_BASE || '').replace(/\/$/, '');
  const fnPath = `/.netlify/functions/${name}`;
  return base ? `${base}${fnPath}` : fnPath;
}

// 开发环境配置
export const DEV_CONFIG = {
  // 是否启用调试模式
  DEBUG: import.meta.env.VITE_DEBUG === 'true',
  
  // 模拟登录（开发时使用）
  MOCK_LOGIN: import.meta.env.VITE_MOCK_LOGIN === 'true',
  
  // 本地存储键名
  STORAGE_KEYS: {
    AUTH: 'googleAuth',
    PROJECTS: 'userProjects',
    CACHE: 'audioCache'
  }
};
